<template lang="html">
  <div class="layout-public">

    <div class="header-public">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <router-link to="/log-in" class="logo">
              <img src="../assets/img/logo-why-care@2x.png" alt="why/care" width="197px" height="59px">
            </router-link>
          </div> <!-- /.col -->
        </div> <!-- /.row -->
      </div> <!-- /.container -->
    </div> <!-- /.header-public -->

    <div class="container">
      <div class="row">
        <div class="col-xl-4 offset-xl-4 col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-10 offset-sm-1">
          <slot></slot>
        </div> <!-- /.col -->
      </div> <!-- /.row -->
    </div> <!-- /.container -->

  </div> <!-- /.layout-public -->
</template>

<script>
export default {
  props: ['practiceName'],
  methods: {

  },
}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

.header-public {
  padding: 75px 0;
  margin-bottom: 0;
  position: relative;

  &:before,
  &:after {
    content: '';
    display: block;
    height: 5px;
    width: 50%;
    position: absolute;
    top: 0;
  }
  &:before {
    left: 0;
    background-color: @color-salmon;
    border-right: 1px solid @light-color;
  }
  &:after {
    left: 50%;
    background-color: @color-green;
  }
}

</style>
